module.exports = __webpack_public_path__ + "img/meteorStrike.5e151d70.png";